import type { GemxQlQueryResponse } from '~/core/gemxql/graphql';
import type { IPageAnalyticsForFilter } from '../types';

import { extractQueryRows, parsePageItems } from '~/core/gemxql/helpers';
import { EMPTY_PAGE_ITEMS } from '~/modules/page-analytic/helpers';
import { EPageMetric } from '~/core/gemxql/types';

export const mapListingRowsToPageAnalytics = (
  response?: GemxQlQueryResponse,
): IPageAnalyticsForFilter[] => {
  const rows = extractQueryRows(response);

  return rows.map((row) => {
    const { [EPageMetric.PAGE_ITEMS]: rawPageItems } = row;
    const pageItems = parsePageItems(rawPageItems) ?? EMPTY_PAGE_ITEMS;

    return {
      locationPath: pageItems.location_path,
      pageTitle: pageItems.page_title,
      pageType: pageItems.page_type,
    };
  });
};
